import { createContext } from 'react';
import { isPlayfulTheme } from '@/lib/layout-version';

// Navegação lúdica (bottom bar, sem sidebar) vs corporativa (sidebar fixa + logo
// na sidebar). Default = tema do build; o PageLayouts sobrescreve pra `false`
// quando o usuário é admin/professor — eles usam a sidebar mesmo em tenant playful.
// Fica num módulo neutro p/ evitar ciclo entre dashboard.jsx e breadcrumbs.jsx.
export const PlayfulNavContext = createContext(isPlayfulTheme());
